import { configuredVolume } from '../constants';

const getConfiguredVolume = (state, action) => {
    if (state === undefined) {
        return {
            configuredVolume: [],
            loading: true,
            error: false,
        };
    }

    switch (action.type) {
        case configuredVolume.GET_CONFIGURED_VOLUME_REQUEST:
            return {
                configuredVolume: [],
                loading: true,
                error: false,
            };

        case configuredVolume.GET_CONFIGURED_VOLUME_SUCCESS:
            return {
                configuredVolume: action.payload,
                loading: false,
                error: false,
            };

        case configuredVolume.CONFIGURED_VOLUME_FAILURE:
            return {
                configuredVolume: [],
                loading: false,
                error: true,
            };

        default:
            return state;
    }
};

export default getConfiguredVolume;
